<template>
  <div class="wellness">
    <div class="banner">
      <div class="banner-box">
        <h1>Support Holistic Wellness
        </h1>
        <el-button class="home-btn" @click="$router.push('/platform')" type="primary">Try it</el-button>
      </div>
      <img class="background" src="@/assets/wellness_banner.png" alt="">
    </div>
    <h1 class="uppercase" style="margin: 5px 0 20px; font-weight: 400;;font-size: 50px;" >HOW <span style="text-transform: capitalize;">RetinaAGE</span> HELPS</h1>
    <h4 class="uppercase" style="width: 60%;margin: 30px auto 80px;font-size: 22px;font-weight: 100">With easy-to-use, accessible technology, <span style="text-transform: capitalize;">RetinaAGE</span> makes personalized health status tracking more convenient than ever</h4>
    <div class="wellness-box">
      <el-card>
        <img src="@/assets/icon3-1.png" alt="">
        <p>Wellness program</p>
      </el-card>
      <el-card>
        <img src="@/assets/icon3-2.png" alt="">
        <p>Health Monitoring</p>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
    };
  },
}
</script>

<style lang="less">
.wellness {
  padding: 0 0 100px;
  .wellness-box {
    .el-card:last-child {
      margin-right: 0;
    }
    .el-card {
      display: inline-block;
      width: 680px;
      height: 400px;
      margin-right: 40px;
    }
    img {
      margin: 50px auto 30px;
    }
    p {
      height: 30px;
      font-weight: 500;
      font-size: 22px;
      color: #222222;
      letter-spacing: 0.69px;
      text-align: center;
    }
  }
  .home-btn {
    width: 200px;
    font-weight: 800;
    border-radius: 50px;
    height: 50px;
    font-size: 23px;
    box-shadow: 0 10px 15px #333 ;
  }
  .banner {
    top: -80px;
    color: white;
    width: 100%;
    position: relative;
    .banner-box {
      text-align: left;
      left: 10%;
      top: 40%;
      z-index: 200;
      position: absolute;
      h1 {
        font-size: 45px;
        text-align: left;
      }
      p {
        text-align: left;
        font-family: 'Regular';
        font-size: 20px;
        color: #FFFFFF;
      }
      button {
        margin-top: 20px;
      }
    }
    .pc {
      width: 500px;
      right: 10%;
      position: absolute;
      bottom: -5%;
      z-index: 200;
    }
    .background {
      width: 100%;
    }
  }
  .step-img {
    width: 80%
  }
  .infos-list {
    margin-top: -80px;
    .background-1 {
      background-image: url('../../assets/research_background_1.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    .background-2 {
      background-image: url('../../assets/research_background_2.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    .info-item {
      padding: 50px 10%;
      min-height: 450px;
      .text-box {
        text-align: left;
        display: inline-block;
        width: 50%;
        vertical-align: top;
        h2 {
          font-size: 33px;
          font-weight: 400;
          padding-left: 30px;
          margin: 80px 0 5px;
        }
        h3 {
          width: 50px;
          height: 5px;;
          background: #F87C3F;
          margin-left: 30px;
          margin-bottom: 5px;;
        }
        p {
          line-height: 40px;
          font-size: 22px;
        }
        .submit-btn {
          width: 220px;
          background: #4C84FF;
          margin-left: 30px;
          margin-top: 30px;
          border-radius: 60px;
          font-size: 22px;
          box-shadow: 0 5px 8px #4C84FF ;
          height: 50px;
          img {
            width: 20px;
            vertical-align: top;
            margin-left: 20px;
          }
        }
        .text-item {
          display: flex;
          vertical-align: top;
          .icon-box {
            width: 90px;
            height: 90px;
            text-align: center;
            background: #F2F2F2;
            border-radius: 10px;
            border: 5px solid #fff;
            box-sizing: border-box;
            box-shadow: 10px 10px 15px #ddd ;
            img {
              width: 100%;
            }
          }
          img {
            display: inline-block;
            width: 150px;
            height: 150px;
            vertical-align: top;
          }
          p {
            display: inline-block;
            vertical-align: top;
            flex: 1;
            margin-top: 35px;;
          }
        }
      }
      .img-box {
        text-align: left;
        padding-top: 50px;
        display: inline-block;
        width: 50%;
        img {
          width: 100%
        }
      }
    }
  }
}
</style>